import { date, InferType, object, ObjectSchema, string } from "yup";
import { CancelarMovimentacaoObraContract } from "../contracts/cancelar-movimentacao-obra.contract";

export const cancelarMovimentacaoObraSchema: ObjectSchema<CancelarMovimentacaoObraContract> = object({

    cancellationDate: date().required("Data de cancelamento é obrigatória"),
    cancellationReason: string().required("Motivo de cancelamento é obrigatório"),
});


export type CancelarMovimentacaoObraFormData = InferType<typeof cancelarMovimentacaoObraSchema>;